import { render, staticRenderFns } from "./firm.vue?vue&type=template&id=30b76862&scoped=true&"
import script from "./firm.vue?vue&type=script&lang=js&"
export * from "./firm.vue?vue&type=script&lang=js&"
import style0 from "./firm.vue?vue&type=style&index=0&id=30b76862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b76862",
  null
  
)

export default component.exports